import { LocalstorageService } from './../services/localstorage.service';
import { GlobalServiceService } from './../services/global-service.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { ApiBasic } from '../services/api-basic'
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CatalogosService {
  private token = ""
  profile: any = this.app.getUserInfo();
  private httpOptions = {
    headers: new HttpHeaders(

      {
        'Content-Type': 'application/json'
      }
    )
  }
  appBase: any;
  subscription: Subscription;
  constructor(
    private http: HttpClient,
    private api: ApiBasic,
    public app: GlobalServiceService,
    public _global: GlobalServiceService,
    private _localstorage: LocalstorageService,
  ) {
    // this._global.base_url = this.api.base_url
    this.token = _global.token
    this.subscription = this._localstorage.getToken().subscribe(message => {
      this.token = _global.token
    });
  }

  public getYears() {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};

    return this.http.get(this._global.base_url + "/maintenances/catanios/mantenimientos", httpOptions)
  }

  public getCatalog(data: any, catalog: string) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    var queryData = this.api.stringfyObject(data)
    return this.http.get(this._global.base_url + "/catalogs" + catalog + "?" + queryData, httpOptions)
  }

  public getCatalogPlantas(data: any, catalog: string) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    var queryData = this.api.stringfyObject(data)
    return this.http.get(this._global.base_url + "/catalogs" + catalog, httpOptions)
  }

  public getCatalogPlantasUsuario(data: any, catalog: string) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    var queryData = this.api.stringfyObject(data)

    return this.http.get(this._global.base_url + "/catalogs" + catalog + "?" + queryData, httpOptions)
  }


  public trucatePlanes() {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.get(this._global.base_url + "/catalogs/truncate/planes", httpOptions)
  }

  public trucateUbicaciones() {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.get(this._global.base_url + "/catalogs/truncate/ubicaciones", httpOptions)
  }

  public trucateActividades() {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.get(this._global.base_url + "/catalogs/truncate/actividades", httpOptions)
  }

  public loadPlanes(file) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.post(this._global.base_url + "/catalogs/planes", file, httpOptions)
  }

  public loadUbicaciones(file) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.post(this._global.base_url + "/catalogs/ubicaciones/tecnicas", file, httpOptions)
  }
  public loadProveedores(data) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.post(this._global.base_url + "/catalogs/provider/masiveloader", data,httpOptions)
  }

  public loadActividades(file) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.post(this._global.base_url + "/catalogs/actividades", file, httpOptions)
  }

  public editPlantas(data) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.post(this._global.base_url + "/catalogs/plantas", data, httpOptions)
  }

  public editAreas(data) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.post(this._global.base_url + "/catalogs/areas", data, httpOptions)
  }

  public editSubareas(data) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.post(this._global.base_url + "/catalogs/subareas", data, httpOptions)
  }

  // public loadOrdenes(file){
  //   return this.http.put(this._global.base_url+"/maintenances/masive/format?user_id=1",file,{})
  // }
  public loadOrdenes(id, file) {
    const httpOptions = {
		  headers: new HttpHeaders({
			// "Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};

    return this.http.put(this._global.base_url + "/maintenances/masive/format?user_id=" + id, file, httpOptions)
  }

  public allFiles() {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.get(this._global.base_url + "/files/routes", httpOptions)
  }

  public downloadFile(path) {
    window.open(this._global.base_image_url + path)
  }

  public getLayoutFiles() {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.get(this._global.base_url + "/files/format/files",httpOptions);
  }

  public consultarMesProveedores(data) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.post(this._global.base_url + "/maintenances/returnproviders", data, httpOptions)
  }

  public consultarPendienteRea(data, mes) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.post(this._global.base_url + "/maintenances/exportReportes?mes=" + mes + '&anio_creado=' + '2021', data, httpOptions)
  }

  public exportMantosFechas(data) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.post(this._global.base_url + "/maintenances/exportReportes", data, httpOptions)
  }

  public getProviders() {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.get(this._global.base_url + "/catalogs/provider/roulette", httpOptions)
  }

  public updateProvider(data) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.patch(this._global.base_url + "/catalogs/provider/roulette", data, httpOptions)
  }

}


